import { useDispatch } from "react-redux";
import { setAmendmentModal, setProposalIdAmendment, setSelectedRequestAmendment } from "../../../features/actuarial/request-amendment/request-amendment.slice";
import { AmendmentRequestData } from "../../../api/request-amendment/request-amendment-api-state";
import { STATUS_STYLES } from "../../../constant/gms-constant";
import TableLoading from "../../ui/table-loading";
import TableError from "../../ui/table-error";
import TableEmpty from "../../ui/table-empty";

const getStatusStyle = (status: string) => {
    const normalizedStatus = status?.toLowerCase();

    return (
        STATUS_STYLES[normalizedStatus] ??
        'border-gray-200 bg-gray-50 text-gray-600'
    );
};


interface Props {
    isLoading: boolean;
    isError: boolean;
    errorMessage: string;
    spinnerColor?: string;
    spinnerSize?: number;
    data: AmendmentRequestData[];
    theadLength: number;
    // handleEdit: (value: number, userID: number, status: string) => void;
}

export default function RequestAmendTbody({ theadLength, isLoading, isError, errorMessage, spinnerColor = '#186cb2', spinnerSize = 25, data, }: Props) {
    
    const dispatch = useDispatch()
    

    return (
        <tbody className="divide-y divide-gray-100">
            {isLoading ? (
                <TableLoading />
            ) : isError ? (
                <TableError description={errorMessage}/>
            ) : !data || data.length === 0 ? (
                <TableEmpty/>
            ) : (
                data?.map((data, index) => (
                    <tr 
                        onClick={() => {
                            dispatch(setAmendmentModal('showAmendmentDetails'))
                            dispatch(setSelectedRequestAmendment(data))
                            dispatch(setProposalIdAmendment(data.application_id))
                        }} 
                        key={data.amendment_id}
                        className={`group cursor-pointer border-b border-gray-100 text-xs transition-colors duration-150 hover:bg-[#186cb2]/5 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'}`}
                    >
                        <td className="px-3 py-1 sm:px-4">
                            <span
                                className={`inline-flex truncate rounded-full border px-2.5 py-1 text-[10px] font-semibold capitalize sm:text-[11px] ${getStatusStyle(data.amendment_status)}`}
                                title={data.amendment_status}
                            >
                                {data.amendment_status}
                            </span>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <div className="truncate text-gray-600" title={data.request_notes}>
                                {data.request_notes
                                    ? data.request_notes.length > 100
                                        ? `${data.request_notes.slice(0, 100)}...`
                                        : data.request_notes
                                    : "-"}
                            </div>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <div className="truncate text-gray-600" title={data.proposal_status_name}>
                                {data.proposal_status_name}
                            </div>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <div className="truncate text-gray-600" title={data.group_name}>
                                {data.group_name}
                            </div>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <div className="truncate text-gray-600" title={data.plan_name}>
                                {data.plan_name}
                            </div>
                        </td>
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <div className="truncate text-gray-600" title={data.requester_name}>
                                {data.requester_name}
                            </div>
                        </td>
                    </tr>
                ))
            )}
        </tbody>
    )
}
